import { SocketHookReturn } from '@/types/camspec';
import { PTZMessage } from '@/types/control';
import useWebSocket from './useWebsocket2';

const PTZ_MESSAGE_TYPE = 'PTZ';

// Someone pans or tilts the camera by hand (joystick, keys, dragging the
// video). Fixed-frame presets listen so a person always wins over aiming.
const manualSteerListeners = new Set<() => void>();
export const onManualSteer = (listener: () => void) => {
  manualSteerListeners.add(listener);
  return () => {
    manualSteerListeners.delete(listener);
  };
};

export const usePTZSocket = (): SocketHookReturn => {
  // WebSocket initialization
  const socket = useWebSocket<PTZMessage>('/control/0.1.0', { throttleTime: 100 });

  const init = () => {
    // wrong as we need to read the default values from the camera before sending them.
    const message = { tilt: 0, pan: 0, zoom: 0 };
    socket.send({ ...message, type: PTZ_MESSAGE_TYPE });
  };

  const setValue = (newPTZMessage: PTZMessage, options?: { automated?: boolean }) => {
    const { pan, tilt, zoom } = newPTZMessage;
    if (!Number.isFinite(pan) || !Number.isFinite(tilt) || !Number.isFinite(zoom)) {
      console.error('Invalid PTZ message', newPTZMessage);
      return;
    }
    if (!options?.automated && (pan !== 0 || tilt !== 0)) {
      manualSteerListeners.forEach((listener) => listener());
    }

    socket.sendImmediately({ ...newPTZMessage, type: PTZ_MESSAGE_TYPE });
  };

  return {
    init,
    setValue,
    reset: init,
  };
};
